<template>
  <div class="client_management">
    <van-sticky>
      <van-nav-bar title="客户管理" left-arrow @click-left="goback()" />
       <div class="management_search">
        <van-search
          v-model="searchValue"
          show-action
          placeholder="输入公司名称/客户名称/手机号搜索"
        >
          <template #action>
            <div @click="onClickButton">搜索</div>
          </template>
        </van-search>
      </div>
    </van-sticky>

    <van-pull-refresh
      v-model="refreshing"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div
          class="magagement_list"
          v-for="(item, index) in employeeList"
          :key="index"
          @click="toClientDetail(item.id)"
        >
          <van-image
            height="70"
            width="70"
            :src="item.portrait"
            fit="cover"
            round
          />
          <div class="list_detail">
            <div>{{ item.nickname }}</div>
            <div>Tel：{{ item.telephone }}</div>
            <div>签约日期:{{ item.signTime }}</div>
          </div>
          <van-icon name="arrow" size="15" />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import { Button, Icon, Image, Search, List, PullRefresh } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Search.name]: Search,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  data() {
    return {
      searchValue: "",
      params: {
        keyword: "",
        page: 1,
        size: 8,
      },
      //员工列表
      employeeList: [],
      loading: false, //底部加载状态
      finished: false, //底部是否完成状态
      refreshing: false,
    };
  },

  created() {
    // 员工管理-列表
    this.employeeManagementList();
  },

  methods: {
    //下拉刷新
    onRefresh() {
      var that = this;
      setTimeout(() => {
        that.params.page = 1;
        // 员工管理-列表
        that.employeeManagementList();
        that.refreshing = false;
        that.finished = false;
      }, 1000);
    },

    //上拉加载
    onLoad() {
      var that = this;
      setTimeout(() => {
        that.employeeManagementList();
      }, 1000);
    },

    // 员工管理-列表
    employeeManagementList() {
      var that = this;
      that.$api
        .customerManagementListAPI(that.params)
        .then(function (res) {
          if (res.data.code === 200) {
            // 如果是第一次进入页面page==1 直接赋值
            if (that.params.page === 1) {
              that.employeeList = res.data.dataList;
            } else {
              that.employeeList = [...that.employeeList, ...res.data.dataList];
            }

            // 当还有数据是page++
            if (res.data.dataList.length > 0) {
              that.params.page++;
              that.loading = false;
            } else {
              // 如果没有数据加载完毕
              that.finished = true;
            }
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //提交搜索条件
    onClickButton() {
      this.params.keyword = this.searchValue;
      this.params.page = 1;
      // 员工管理-列表
      this.employeeManagementList();
    },

    toClientDetail(id) {
      this.$router.push({ path: "/place/clientDetail", query: { id: id } });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.client_management {
  .management_search {
    background: #eaeaea;
    padding: 10px 15px;
  }

  .van-search {
    padding: unset;
  }

  /deep/ .van-search__action {
    background: #2295ff;
    color: #fff;
    border-radius: 0px 5px 5px 0px;
  }

  .magagement_list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 7px solid #eaeaea;

    .list_detail {
      display: flex;
      width: 215px;
      flex-direction: column;
      font-size: 12px;

      div {
        &:nth-child(1) {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/place/clientManagement.vue